import { useDashboardData } from '@/hooks/useDashboardData'
import useFilterStore from '@/store/useFilterStore'

const TopMatchCountPrefectures = () => {
  const { data, isLoading, error } = useDashboardData()
  const { selectedPrefectures } = useFilterStore()

  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <div className="animate-pulse">
          <div className="h-6 bg-gray-200 rounded mb-4"></div>
          <div className="space-y-3">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="h-12 bg-gray-200 rounded"></div>
            ))}
          </div>
        </div>
      </div>
    )
  }

  if (error || !data) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-500">データの読み込みに失敗しました</p>
      </div>
    )
  }

  const { topMatchCountPrefectures } = data

  if (!topMatchCountPrefectures || topMatchCountPrefectures.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h2 className="text-lg font-semibold text-gray-900 mb-4">対戦数上位10県</h2>
        <p className="text-gray-500">データがありません</p>
      </div>
    )
  }

  // 選択中の都道府県を除外
  const filteredPrefectures = selectedPrefectures.length > 0
    ? topMatchCountPrefectures.filter(item => !selectedPrefectures.includes(item.prefectureId))
    : topMatchCountPrefectures

  // 除外後の上位10件を取得
  const displayPrefectures = filteredPrefectures.slice(0, 10)

  // 順位を再計算（1から始まる）
  const rankedPrefectures = displayPrefectures.map((item, index) => ({
    ...item,
    rank: index + 1
  }))

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h2 className="text-lg font-semibold text-gray-900 mb-6">対戦数上位10県</h2>
      {selectedPrefectures.length > 0 && (
        <p className="text-sm text-gray-500 mb-4">
          選択中の都道府県はランキングから除外されています
        </p>
      )}
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">順位</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">都道府県</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">対戦数</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">勝率</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">勝利</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">敗戦</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {rankedPrefectures.map((item) => (
              <tr key={item.prefectureId}>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {item.rank}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {item.prefectureName}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-blue-600">
                  {item.totalMatches}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.winRate.toFixed(1)}%
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.totalWins}
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {item.totalLosses}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default TopMatchCountPrefectures
